export const UPDATE_USER = '@uhc/utility/UPDATE_USER';
export const VALIDATE_USER = '@uhc/utility/VALIDATE_USER';
export const GET_USER_DETAILS = '@uhc/utility/GET_USER_DETAILS';
export const REFRESH_SESSION = '@uhc/utility/REFRESH_SESSION';
